// extracted by mini-css-extract-plugin
module.exports = {"root":"BmiRanges_root__2PoVV","ranges":"BmiRanges_ranges__1Ogup"};